import { z } from 'zod';
export const componentClassSchema = z.enum(['whole_blood', 'red_cell', 'plasma', 'platelet']);
export const bloodGroupSchema = z.enum(['O', 'A', 'B', 'AB']);
export const rhFactorSchema = z.enum(['positive', 'negative']);
export const anticoagulantSchema = z.enum(['CPD', 'CPDA_1', 'CP2D', 'SAGM', 'ACD_A']);
export const patientCategorySchema = z.enum([
    'non_jkn', 'jkn_thalassemia', 'jkn_leukemia', 'jkn_hemodialysis',
]);
export const BLOOD_GROUPS = ['O', 'A', 'B', 'AB'];
export const RH_FACTORS = ['positive', 'negative'];
export const COMPONENT_CLASSES = ['whole_blood', 'red_cell', 'plasma', 'platelet'];
export const COMPONENT_CLASS_LABELS = {
    whole_blood: 'Darah Lengkap',
    red_cell: 'Sel Darah Merah',
    plasma: 'Plasma',
    platelet: 'Trombosit',
};
export const PATIENT_CATEGORY_LABELS = {
    non_jkn: 'Non-JKN',
    jkn_thalassemia: 'JKN — Thalasemia Mayor',
    jkn_leukemia: 'JKN — Leukemia',
    jkn_hemodialysis: 'JKN — Hemodialisis',
};
export const ANTICOAGULANT_LABELS = {
    CPD: 'CPD',
    CPDA_1: 'CPDA-1',
    CP2D: 'CP2D',
    SAGM: 'SAGM (aditif)',
    ACD_A: 'ACD-A (apheresis)',
};
/** Format a blood type for display: O+, AB-, and so on. */
export function formatBloodType(abo, rh) {
    return `${abo}${rh === 'positive' ? '+' : '−'}`;
}
export const compatibilityQuerySchema = z.object({
    componentClass: componentClassSchema,
    recipientAbo: bloodGroupSchema,
    recipientRh: rhFactorSchema,
});
